/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AffiliateCustomersRequestBuilderRequestsMetadata, type AffiliateCustomersRequestBuilder } from './affiliateCustomers/index.js';
// @ts-ignore
import { BusinessCustomersRequestBuilderRequestsMetadata, type BusinessCustomersRequestBuilder } from './businessCustomers/index.js';
// @ts-ignore
import { ChargepointConsumptionRequestBuilderNavigationMetadata, type ChargepointConsumptionRequestBuilder } from './chargepointConsumption/index.js';
// @ts-ignore
import { ConsumerCustomersRequestBuilderRequestsMetadata, type ConsumerCustomersRequestBuilder } from './consumerCustomers/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /ingests
 */
export interface IngestsRequestBuilder extends BaseRequestBuilder<IngestsRequestBuilder> {
    /**
     * The affiliateCustomers property
     */
    get affiliateCustomers(): AffiliateCustomersRequestBuilder;
    /**
     * The businessCustomers property
     */
    get businessCustomers(): BusinessCustomersRequestBuilder;
    /**
     * The chargepointConsumption property
     */
    get chargepointConsumption(): ChargepointConsumptionRequestBuilder;
    /**
     * The consumerCustomers property
     */
    get consumerCustomers(): ConsumerCustomersRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const IngestsRequestBuilderUriTemplate = "{+baseurl}/ingests";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const IngestsRequestBuilderNavigationMetadata: Record<Exclude<keyof IngestsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    affiliateCustomers: {
        requestsMetadata: AffiliateCustomersRequestBuilderRequestsMetadata,
    },
    businessCustomers: {
        requestsMetadata: BusinessCustomersRequestBuilderRequestsMetadata,
    },
    chargepointConsumption: {
        navigationMetadata: ChargepointConsumptionRequestBuilderNavigationMetadata,
    },
    consumerCustomers: {
        requestsMetadata: ConsumerCustomersRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
